import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MainService from "../../helper/mainService";
import ApiService from "../../helper/api";
import { logoutUser } from "../../store/reducers/UserReducer";

const Logout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { token } = useSelector(state => state.user);

	useEffect(() => {
		if (token) {
			dispatch(logoutUser());
		}
	}, [token]);

	useEffect(() => {
		if (!token) {
			navigate("/", { replace: true });
		}
	}, [token]);
	return <></>;
};
export default Logout;
